// extracted by mini-css-extract-plugin
export default {"root__container":"Accordion_root__container__FSK-P","accordion__button":"Accordion_accordion__button__jvoEw"};